import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-atricon-layout',
  standalone: false,
  templateUrl: './atricon-layout.component.html',
  styleUrl: './atricon-layout.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None
})
export class AtriconLayoutComponent {
}
